export const limitSeparate = (limit, nonBreakingSpace = false) => {
    const strLimit = limit.toString();
      const s = strLimit.length;
      const chars = strLimit.split("");
        const strWithSpaces = chars.reduceRight((acc, char, i) => {
        const space = nonBreakingSpace ? "\u00a0" : " ";
        const spaceOrNothing = ((((s - i) % 3) === 0) ? space : "");
        return (spaceOrNothing + char + acc);
        }, "");

      return ((strWithSpaces[0] === " ") ? strWithSpaces.slice(1) : strWithSpaces);
  };
